

import { toCurrency } from '../../../helpers'
import { Td, Table, Th } from '../style'

function FinancialPendenciesPefin({consultaJson}){
    return(
        <div id="financialPendenciesPefin">
        <Table>
          <tr>
            <Th style={{ color: "#255391", background: "#dee5eb" }}>
              Pendências Financeiras Pefin
            </Th>
          </tr>
        </Table>

        {consultaJson?.report?.financialPendencies?.pefin?.occurrences?.length > 0 ? (
          <>
            <Table>
              <tr
                style={{ backgroundColor: "#e6e6e6", color: "#666263" }}
              >
                <Th>Data </Th>
                <Th>Modalidade </Th>
                <Th>Aval. </Th>
                <Th>Valor </Th>
                <Th>Contrato </Th>
                <Th>Origem </Th>
                <Th>Praça </Th>
              </tr>
              {consultaJson?.report?.financialPendencies?.pefin?.occurrences.map(
                (item) => {
                  return (
                    <tr>
                      <Td> {item?.date} </Td>
                      <Td> {item?.modality} </Td>
                      <Td> {item?.isGuarantor ? "SIM" : "NÃO"} </Td>
                      <Td> {item?.value && toCurrency(item?.value)} </Td>
                      <Td> {item?.contract} </Td>
                      <Td> {item?.origin} </Td>
                      <Td> {item?.embratelInitials} </Td>
                    </tr>
                  );
                }
              )}
            </Table>
            <Table>
              <tr>
                <Th style={{ color: "#255391", background: "#dee5eb" }}>
                  Total de ocorrências{" "}
                  {consultaJson?.report?.financialPendencies.pefin.total}.
                  Periodo{" "}
                  {
                    consultaJson?.report?.financialPendencies.pefin
                      .oldestOccurrenceDate
                  }{" "}
                  a{" "}
                  {
                    consultaJson?.report?.financialPendencies.pefin
                      .newestOccurrenceDate
                  }{" "}
                  valor total das ocorrencias{" "}
                  {consultaJson?.report?.financialPendencies.pefin
                    .totalValue &&
                    toCurrency(
                      consultaJson?.report?.financialPendencies.pefin
                        .totalValue
                    )}{" "}
                </Th>
              </tr>
            </Table>
          </>
        ) : (
          <Table>
            <tr>
              <Th>NÃO CONSTAM OCORRENCIAS</Th>
            </tr>
          </Table>
        )}
        {/* Validação se não tiver ocorrencias  */}
      <br />
      </div>
    )
}

export default FinancialPendenciesPefin